<template>
  <div class="bq-intro">
    <section-title title="关于扁鹊" />
    <div class="about-container">
      <div class="about-img">
        <img
          src="https://img.alicdn.com/tfs/TB1nO.lCrr1gK0jSZR0XXbP8XXa-1200-900.png"
          alt="公司文化"
        />
      </div>
      <div class="container">
        <div class="left-mark"></div>
        <p>
          浙江扁鹊健康科技有限公司
          ，由阿里巴巴集团旗下阿里健康和蚂蚁金服共同投资设立，系阿里健康下属公司。
        </p>
        <p>
          公司基于阿里巴巴集团先进的云计算和大数据技术能力、丰富的互联网行业运营
          经验，通过医疗健康信息与云计算、大数据、人工智能等领域的深度结合，探索
          医疗健康新型服务，促进产业链上下游直径的信息流动、业务协同和互联互通。
          同时，在卫生服务、行政监管、便民体验等域，借助阿里的互联网运营经验和入
          口优势提供多种应用服务。
        </p>
        <div class="right-mark"></div>
      </div>
    </div>
    <section-title title="公司文化" />
    <div class="bq-culture"></div>
  </div>
</template>

<script>
import SectionTitle from '@/components/website_v3/SectionTitle';

export default {
  name: 'Intro',

  components: {
    SectionTitle,
  },

  data() {
    return {
      // banner,
    };
  },

  // created() {
  // },

  // mounted() {
  //   this.$route.query.locat && this.locatTo(this.$route.query.locat);
  // },

  // methods: {
  // },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
